import React from 'react';
import ArticleListPage from './ArticleListPage';
import { detectionDispatchPosts } from '../config/detectionDispatchPosts';

const DetectionDispatchPage = () => (
  <ArticleListPage
    badge="Detection Dispatch"
    title="Detection Engineering Notes,"
    accentWord="Mapped to ATT&CK."
    desc="Fresh detection content and engineering notes from our SOC — the actual rules, tuning logic, and false-positive tradeoffs, not just theory."
    sectionTag="Latest Notes"
    sectionTitle="From the Proven InfoSec SOC Team"
    sectionDesc="Practical detection logic our analysts use every day, shared so your own team can build on it."
    posts={detectionDispatchPosts}
    basePath="/detection-dispatch"
  />
);

export default DetectionDispatchPage;
